import { string, arrayOf, shape, bool, number, oneOfType } from 'prop-types';
import ReactSelect from 'react-select';
import themeObj from '../../config/theme';

function Select ({id, options, placeholder, disabled, touched, invalid, customComponents, ...rest}) {

  return (
    <ReactSelect
      inputId={id}
      styles={{
        control: (provided, state) => {
          return ({
          ...provided,
          position: 'relative',
          overflow: 'hidden',
          padding: '0.25rem',
          backgroundColor: state.isDisabled ? themeObj.colors.bg_gray : themeObj.colors.bg_white,
          cursor: 'default',
          outline: 'none',
          border: `1px solid ${state.isDisabled ? themeObj.colors.bg_gray_dark : (touched && invalid ? themeObj.colors.negative : themeObj.colors.input_border)}`,
          display: 'flex',
          justifyContent: 'space-between',
          borderRadius: 0,
          "&:hover": {
            border: `1px solid ${touched && invalid ? themeObj.colors.negative_bg : themeObj.colors.information_bg} `,
          }
        })},
        valueContainer: (provided) => ({
          ...provided,
          padding: 0,
          lineHeight: 1,
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'wrap',
        }),
        input: (provided) => ({
          ...provided,
          margin: '0 0.25rem',
        }),
        menu: (provided) => ({
          ...provided,
          position: 'absolute',
          left: '0',
          top: '3em',
          width: '100%',
          backgroundColor: themeObj.colors.bg_white,
          border: `1px solid ${themeObj.colors.brand_blue}`,
          zIndex: 25,
          userSelect: 'none',
          borderRadius: 0,
        }),
        option: (provided, state) => ({
          ...provided,
          lineHeight: 1,
          padding: '0.75rem',
          backgroundColor: state.isSelected ? 'rgba(195, 226, 245, 0.3)' : 'inherit',
          color: themeObj.colors.text_dark,
          "&:hover": {
            backgroundColor: 'rgba(195, 226, 245, 0.3)',
          },
        }),
        singleValue: (provided, state) => ({
          ...provided,
          color: state.isDisabled ? themeObj.colors.bg_gray_dark : themeObj.colors.text_dark,
        }),
        indicatorSeparator: (provided) => ({
          ...provided,
          display: 'none',
        }),
        dropdownIndicator: (provided) => ({
          ...provided,
          padding: '7px',
          color: themeObj.colors.text_dark,
          "&:hover": {
            color: themeObj.colors.text_dark,
          }
        }),
      }}
      options={options}
      components={customComponents}
      placeholder={placeholder}
      isDisabled={disabled}
      {...rest}
    />
  );
}

Select.propTypes = {
  id: string.isRequired,
  options: arrayOf(
    shape({
      value: oneOfType([string, number]),
      label: oneOfType([string, number]),
    })
  ).isRequired,
  placeholder: string,
  disabled: bool,
  touched: bool.isRequired,
  invalid: bool.isRequired,
  customComponents: shape({}),
};

Select.defaultProps = {
  placeholder: 'Select...',
  disabled: false,
  customComponents: {},
};

export default Select;